import { render, staticRenderFns } from "./AddPaymentMethodView.vue?vue&type=template&id=182d4c28&scoped=true&"
import script from "./AddPaymentMethodView.vue?vue&type=script&lang=js&"
export * from "./AddPaymentMethodView.vue?vue&type=script&lang=js&"
import style0 from "./AddPaymentMethodView.vue?vue&type=style&index=0&id=182d4c28&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182d4c28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAppBar,VBtn,VIcon})
